import { twMerge } from 'tailwind-merge';
import { BasicStoreFragment } from 'drycut-graphql';

type Props = {
  className?: string;
  store: BasicStoreFragment;
};

export function PromotionBadge({ store, className = '' }: Props): React.ReactNode {
  const mergedClassNames = twMerge('absolute w-28 lg:w-36 -rotate-12', className);

  const showBadge = store.promotionBadgeActive && store.promotionBadge.attached;

  // Check if the promotion badge is available and if it has a download link, otherwise return null
  if (!showBadge || !store.promotionBadge.downloadLink) {
    return null;
  }

  return (
    <div className={mergedClassNames}>
      <img src={store.promotionBadge.downloadLink} alt="promotion-badge" width="100%" />
    </div>
  );
}
